/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import { ButtonSubmit, Container, Content, Title } from '../../GlobalStyle'
import BoxShadow from '../components/BoxShadowDiv'
import { MonthButton, Table, Total, TotalText, TotalTitle } from './style'

import { ProgressSpinner } from 'primereact/progressspinner'
import { AiFillCaretRight, AiOutlinePlus } from 'react-icons/ai'
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import api from '../../hooks/API'
import apiPdv from '../../hooks/API_PDV'
import { Mask } from '../../hooks/Mask'
import { CurrencyInput } from '../../hooks/MaskInput'
import {
  useAddAppSales,
  useAddFixedExpensesSales,
  useAddMethodsSales,
  useAddNotesSales,
  useDeleteMethodsSales,
  useUpdateFixedExpensesSales,
} from '../../hooks/mutations'
import {} from '../../hooks/removeFormat'
import { Button } from '../components/Buttons/NormalButtons'
import TrashButton from '../components/Buttons/NormalButtons/TrashButton'
import Header from '../components/Header'
import { Input } from '../components/Input/style'
import { Line } from '../components/Line'

const Sales = () => {
  const {
    data: salesPDV,

    isLoading: salesLoading,
  } = useQuery(['sales'], () => apiPdv.getSales())
  const { data: salesData, isLoading } = useQuery(['fixedSales'], () => api.getFixedSalesExpenses())
  const [salesNote, setSalesNote] = useState([])
  const [salesApp, setSalesApp] = useState([])
  const { isLoading: isLoadingNotes, data: notesAllData } = useQuery(['notesSalesAll'], () =>
    api.getNotesSales()
  )
  const { isLoading: isLoadingApp, data: appData } = useQuery(['appSales'], () => api.getAppSales())
  const [firstInitialization, setFirstInitialization] = useState(true)
  const [salesMethods, setSalesMethods] = useState([])
  const [removedItems, setRemovedItems] = useState([])
  const [sales, setSales] = useState({ sale1: 0, sale2: 0, sale3: 0 })
  const [salesMethodsTotal, setSalesMethodsTotal] = useState({ sale1: 0, sale2: 0, sale3: 0 })
  const [salesAppTotal, setsalesAppTotal] = useState({ sale1: 0, sale2: 0, sale3: 0 })

  const [totalSales, settotalSales] = useState(0)
  const [currentMonthIndex, setCurrentMonthIndex] = useState()
  const [isLoadingState, setIsLoadingState] = useState(true)

  const nextMonth = (currentMonthIndex - 1 + 12) % 12
  const nextNextMonth = (currentMonthIndex - 2 + 12) % 12

  const [lastThreeMonths, setLastThreeMonths] = useState([
    getMonthName(nextNextMonth),
    getMonthName(nextMonth),
    getMonthName(currentMonthIndex),
  ])

  useEffect(() => {
    const currentMonthIndexNew = salesData?.partida_mes
    if (currentMonthIndexNew) {
      setLastThreeMonths([
        getMonthName((currentMonthIndexNew - 2 + 12) % 12),
        getMonthName((currentMonthIndexNew - 1 + 12) % 12),
        getMonthName(currentMonthIndexNew),
      ])

      setCurrentMonthIndex(currentMonthIndexNew)
    }
  }, [salesData])

  const { mutate: addFixedExpenseSales } = useAddFixedExpensesSales()
  const { mutate: updateFixedExpensesSales } = useUpdateFixedExpensesSales()
  const { mutate: addMethodsSales } = useAddMethodsSales()
  const { mutate: addNotesSales } = useAddNotesSales()
  const { mutate: addAppSales } = useAddAppSales()
  const { mutate: deleteMethodsSales } = useDeleteMethodsSales()

  const { data: methodsSalesData } = useQuery(['methodsSales'], () => api.getMethodsSales())

  const groupByMonth = (data, year) => {
    const result = new Array(12).fill(0)

    data?.forEach((obj) => {
      const date = new Date(obj.data)
      if (date.getFullYear() === year) {
        result[date.getMonth()] += Number(obj.valor)
      }
    })

    return result
  }

  const groupBySalesWithOrWithoutNote = (dataList, year) => {
    const groupedData = []
    let methods = []
    if (methods.length <= 0) methods = ['withNote', 'withoutNote']
    let id = 1
    methods?.forEach((method) => {
      groupedData.push({ id: id++, nome: method, meses: [] })
    })
    dataList?.forEach((data) => {
      if (data?.comNota === 1) {
        const index = groupedData.findIndex((item) => item.nome === 'withNote')
        groupedData[index].meses.push(data)
      } else {
        const index = groupedData.findIndex((item) => item.nome === 'withoutNote')
        groupedData[index].meses.push(data)
      }
    })
    groupedData.forEach((item) => {
      item.meses = groupByMonth(item.meses, year)
    })
    return groupedData
  }

  const groupByOnlineorApp = (dataList, year) => {
    const groupedData = []
    let methods = []
    if (methods.length <= 0) methods = ['withOnline', 'withApp']
    let id = 1
    methods?.forEach((method) => {
      groupedData.push({ id: id++, nome: method, meses: [] })
    })

    groupedData.forEach((item) => {
      item.meses = groupByMonth(item.meses, year)
    })
    return groupedData
  }
  const groupByPaymentMethod = (dataList, year) => {
    const groupedData = []
    let methods = methodsSalesData.map((x) => x.nome)

    if (methods.length <= 0) methods = ['Pix', 'Dinheiro', 'Cartão', 'Cheque']
    let id = 1
    methods?.forEach((method) => {
      groupedData.push({ id: id++, nome: method, meses: [] })
    })
    dataList?.forEach((data) => {
      data?.methods.forEach((method) => {
        const index = groupedData.findIndex((item) => item.nome === method.nome)
        if (index === -1) {
          groupedData.push({ id: id++, nome: method.nome, meses: [] })
        } else {
          groupedData[index].meses.push(method)
        }
      })
    })
    groupedData.forEach((item) => {
      item.meses = groupByMonth(item.meses, year)
    })
    return groupedData
  }

  const calculateBySales = () => {
    let methodCounts = {}
    let noteCounts = { withNote: Array(12).fill(0), withoutNote: Array(12).fill(0) }

    salesPDV.map((sale) => {
      let month = new Date(sale.data).getMonth()
      sale.comNota
        ? (noteCounts.withNote[month] += parseFloat(sale.valor))
        : (noteCounts.withoutNote[month] += parseFloat(sale.valor))

      sale.methods.map((method) => {
        if (!methodCounts[method.nome]) {
          methodCounts[method.nome] = Array(12).fill(0)
        }
        methodCounts[method.nome][month] += parseFloat(method.valor)
      })
    })

    const sortedNoteCounts = Object.entries(noteCounts).map(([nome, meses]) => ({ nome, meses }))
    const sortedMethods = Object.entries(methodCounts).map(([nome, meses]) => ({ nome, meses }))

    const newMethods = salesMethods.map((newItem) => {
      const existingItemIndex = sortedMethods.findIndex((item) => item.nome == newItem.nome)

      return existingItemIndex != -1 ? sortedMethods[existingItemIndex] : newItem
    })
    setSalesMethods(newMethods)
    setSalesNote(sortedNoteCounts)
  }

  const updateData = (data, groupByFunction, setDataFunction) => {
    const groupedData = groupByFunction([], 2023)
    data?.map((item) => {
      try {
        const dataFound = groupedData.find((obj) => obj.nome === item.nome)
        dataFound.id = item.id
        dataFound.meses[currentMonthIndex] = item.mes_3
        dataFound.meses[nextMonth] = item.mes_2
        dataFound.meses[nextNextMonth] = item.mes_1
      } catch (e) {
        null
      }
    })
    setDataFunction(groupedData)
    return groupedData
  }
  const handleRemoveRow = (index) => {
    if (salesMethods[index].id) {
      setRemovedItems([...removedItems, salesMethods[index].id])
    }

    const list = [...salesMethods]
    list.splice(index, 1)
    setSalesMethods(list)
  }
  const handleCloneRow = (index, data, functionData) => {
    const newState = data.map((obj, i) => {
      if (i == index) {
        return {
          ...obj,
          meses: {
            ...obj.meses,
            [currentMonthIndex]: obj.meses[nextNextMonth],
            [nextMonth]: obj.meses[nextNextMonth],
          },
        }
      }
      return obj
    })
    functionData(newState)
  }

  useEffect(() => {
    if (firstInitialization && notesAllData && methodsSalesData && appData && currentMonthIndex) {
      updateData(notesAllData, groupBySalesWithOrWithoutNote, setSalesNote)
      updateData(appData, groupByOnlineorApp, setSalesApp)
      updateData(methodsSalesData, groupByPaymentMethod, setSalesMethods)
      setFirstInitialization(false)
      setIsLoadingState(false)
    }
  }, [notesAllData, methodsSalesData, appData, currentMonthIndex])

  useEffect(() => {
    let sum = 0
    sum += sales.sale1 + sales.sale2 + sales.sale3
    settotalSales(sum)
  }, [sales])

  const handleNextMonth = () => {
    setCurrentMonthIndex((currentMonthIndex + 1) % 12)
    setLastThreeMonths([
      getMonthName((currentMonthIndex - 1 + 12) % 12),
      getMonthName(currentMonthIndex),
      getMonthName((currentMonthIndex + 1) % 12),
    ])
  }
  const handlePreviousMonth = () => {
    setCurrentMonthIndex(nextMonth)
    setLastThreeMonths([
      getMonthName((currentMonthIndex - 3 + 12) % 12),
      getMonthName(nextNextMonth),
      getMonthName(nextMonth),
    ])
  }

  const handleSave = () => {
    removedItems.forEach((id) => {
      deleteMethodsSales(id)
    })
    setRemovedItems([])
    function saveData(data, addFunction, total) {
      data.map((item) => {
        let mes_1 = item.meses[nextNextMonth]
        let mes_2 = item.meses[nextMonth]
        let mes_3 = item.meses[currentMonthIndex]
        const obj = {
          nome: item.nome,
          meses: [mes_1, mes_2, mes_3],
          percentual: avrg(item.meses, total.sale1 + total.sale2 + total.sale3),
          valorMensal: mes_3,
        }
        addFunction(obj)
      })
    }
    saveData(salesMethods, addMethodsSales, salesMethodsTotal)
    saveData(salesNote, addNotesSales, sales)
    saveData(salesApp, addAppSales, salesAppTotal)

    if (sales.id)
      updateFixedExpensesSales({
        id: sales.id,
        meses: [sales.sale1, sales.sale2, sales.sale3],
        partida_mes: currentMonthIndex,
      })
    else
      addFixedExpenseSales({
        meses: [sales.sale1, sales.sale2, sales.sale3],
        partida_mes: currentMonthIndex,
      })

    toast.success('Despesas atualizadas com sucesso')
  }

  const recalculateSalesTotal = (data, index) => {
    const sum = data.reduce((acc, curr) => acc + curr.meses[index], 0)
    return sum
  }

  useEffect(() => {
    const updatedTotal = {
      ...salesMethodsTotal,
      sale1: recalculateSalesTotal(salesMethods, nextNextMonth),
      sale2: recalculateSalesTotal(salesMethods, nextMonth),
      sale3: recalculateSalesTotal(salesMethods, currentMonthIndex),
    }
    setSalesMethodsTotal(updatedTotal)
  }, [removedItems, salesMethods, currentMonthIndex])

  useEffect(() => {
    const updatedTotal = {
      ...salesNote,
      sale1: recalculateSalesTotal(salesNote, nextNextMonth),
      sale2: recalculateSalesTotal(salesNote, nextMonth),
      sale3: recalculateSalesTotal(salesNote, currentMonthIndex),
    }
    setSales(updatedTotal)
  }, [salesNote, currentMonthIndex])

  useEffect(() => {
    const updatedTotal = {
      ...salesApp,
      sale1: recalculateSalesTotal(salesApp, nextNextMonth),
      sale2: recalculateSalesTotal(salesApp, nextMonth),
      sale3: recalculateSalesTotal(salesApp, currentMonthIndex),
    }
    setsalesAppTotal(updatedTotal)
  }, [salesApp, currentMonthIndex])

  const handleChange = (event, index, value, functionData, data) => {
    const { id, name } = event.target

    const newObj = [...data]
    const paymentMethodObject = newObj.find((obj) =>
      name != 'name' ? obj.nome == name : obj.id == id
    )

    if (name == 'name') {
      paymentMethodObject.nome = event.target.value
    } else {
      paymentMethodObject.meses[index] = value
    }
    functionData(newObj)
  }

  const avrg = (sales, total) => {
    const sale1 = sales[currentMonthIndex]
    const sale2 = sales[nextMonth]
    const sale3 = sales[nextNextMonth]

    const avrgData = ((sale1 + sale2 + sale3) / total) * 100
    return avrgData
  }

  const updateTableForNewMonth = () => {}

  const createNewMethod = () => {
    setSalesMethods((prevState) => [
      ...prevState,
      { id: prevState.length + 1, nome: '', meses: new Array(12).fill(0) },
    ])
  }
  function getMonthName(monthIndex) {
    const monthNames = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ]
    return monthNames[monthIndex]
  }

  if (isLoading || isLoadingNotes || isLoadingApp || isLoadingState)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )

  return (
    <Content>
      <Title>Vendas</Title>
      <BoxShadow overflow={'initial'} minWidth={'550px'}>
        <Header title={'Definir Vendas'} />

        <Container>
          <Total>
            <TotalTitle>Vendas por mês {process.env.API_URL}</TotalTitle>

            <TotalText>
              <ButtonSubmit width={'200px'} margin={0} invert onClick={() => calculateBySales()}>
                Automático
              </ButtonSubmit>
              <span>R$</span>
              {Mask.money(totalSales).slice(3)}
            </TotalText>
          </Total>

          <Table>
            <thead>
              <tr>
                <th style={{ width: '22%' }}>Tipo de venda</th>
                <th style={{ width: '22%' }}>{lastThreeMonths[0]}</th>
                <th style={{ width: '22%' }}>{lastThreeMonths[1]}</th>
                <th style={{ width: '22%' }}>{lastThreeMonths[2]}</th>
                <th style={{ width: '12%', minWidth: '75px' }}>%</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <MonthButton onClick={handleNextMonth}>
                <HiOutlineChevronRight />
              </MonthButton>

              <MonthButton plus onClick={handlePreviousMonth}>
                <HiOutlineChevronLeft />
              </MonthButton>

              <tr>
                <td>
                  <Input type="text" name="name" value={'Totais'} disabled />
                </td>
                <td>
                  <CurrencyInput type="text" name="sale1" value={sales.sale1} disabled />
                </td>
                <td>
                  <CurrencyInput type="text" name="sale2" value={sales.sale2} disabled />
                </td>
                <td>
                  <CurrencyInput type="text" name="sale3" value={sales.sale3} disabled />
                </td>
                <td>
                  <CurrencyInput
                    currency={'percent'}
                    type="text"
                    name="percent"
                    value={100}
                    disabled
                  />
                </td>
              </tr>

              {salesNote.map((sale, index) => (
                <tr key={sale.id}>
                  <td>
                    <Input
                      type="text"
                      name="name"
                      value={sale.nome == 'withNote' ? 'Vendas fiscais' : 'Vendas com recibo'}
                      disabled
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      id="1"
                      type="text"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, nextNextMonth, originalValue, setSalesNote, salesNote)
                      }
                      value={sale.meses[nextNextMonth]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      id="2"
                      type="text"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, nextMonth, originalValue, setSalesNote, salesNote)
                      }
                      value={sale.meses[nextMonth]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      id="3"
                      type="text"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, currentMonthIndex, originalValue, setSalesNote, salesNote)
                      }
                      value={sale.meses[currentMonthIndex]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      currency={'percent'}
                      type="text"
                      name="percent"
                      value={avrg(sale.meses, totalSales)}
                      disabled
                    />
                  </td>

                  <td>
                    <Button
                      color={'#3460a6'}
                      onClick={() => handleCloneRow(index, salesNote, setSalesNote, setSales)}
                    >
                      <AiFillCaretRight style={{ position: 'absolute' }} />
                    </Button>
                  </td>
                </tr>
              ))}

              {
                // SEPARACAO PARA OS METODOS
              }
              <tr>
                <td colSpan={4}>
                  <Line />
                </td>
              </tr>

              <tr>
                <td>
                  <Input type="text" name="name" value={'Totais'} disabled />
                </td>
                <td>
                  <CurrencyInput
                    type="text"
                    name="sale1"
                    value={salesMethodsTotal.sale1}
                    disabled
                  />
                </td>
                <td>
                  <CurrencyInput
                    type="text"
                    name="sale2"
                    value={salesMethodsTotal.sale2}
                    disabled
                  />
                </td>
                <td>
                  <CurrencyInput
                    type="text"
                    name="sale3"
                    value={salesMethodsTotal.sale3}
                    disabled
                  />
                </td>
                <td>
                  <CurrencyInput type="text" name="avrg" value={100} disabled />
                </td>
              </tr>

              {salesMethods.map((sale, index) => (
                <tr key={sale.nome}>
                  <td>
                    <Input
                      type="text"
                      name="name"
                      value={sale.nome}
                      id={sale.id}
                      onChange={(e) =>
                        handleChange(e, undefined, undefined, setSalesMethods, salesMethods)
                      }
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      type="text"
                      id="1"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, nextNextMonth, originalValue, setSalesMethods, salesMethods)
                      }
                      value={sale.meses[nextNextMonth]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      type="text"
                      id="2"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, nextMonth, originalValue, setSalesMethods, salesMethods)
                      }
                      value={sale.meses[nextMonth]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      type="text"
                      id="3"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(
                          e,
                          currentMonthIndex,
                          originalValue,
                          setSalesMethods,
                          salesMethods
                        )
                      }
                      value={sale.meses[currentMonthIndex]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      currency={'percent'}
                      type="text"
                      name={'avrg'}
                      value={avrg(
                        sale.meses,
                        salesMethodsTotal.sale1 + salesMethodsTotal.sale2 + salesMethodsTotal.sale3
                      )}
                      disabled
                    />
                  </td>
                  <td>
                    <Button
                      color={'#3460a6'}
                      onClick={() => handleCloneRow(index, salesMethods, setSalesMethods)}
                    >
                      <AiFillCaretRight style={{ position: 'absolute' }} />
                    </Button>
                  </td>
                  <td>
                    <TrashButton onClick={() => handleRemoveRow(index)} />
                  </td>
                </tr>
              ))}
              <ButtonSubmit
                rounded
                width={'auto'}
                height={'auto'}
                padding={'12px'}
                onClick={() => createNewMethod()}
              >
                <AiOutlinePlus />
              </ButtonSubmit>

              <tr>
                <td colSpan={4}>
                  <Line />
                </td>
              </tr>

              <tr>
                <td>
                  <Input type="text" name="name" value={'Totais'} disabled />
                </td>
                <td>
                  <CurrencyInput type="text" name="sale1" value={salesAppTotal.sale1} disabled />
                </td>
                <td>
                  <CurrencyInput type="text" name="sale2" value={salesAppTotal.sale2} disabled />
                </td>
                <td>
                  <CurrencyInput type="text" name="sale3" value={salesAppTotal.sale3} disabled />
                </td>

                <td>
                  <CurrencyInput
                    currency={'percent'}
                    type="text"
                    name={'avrg'}
                    value={100}
                    disabled
                  />
                </td>
              </tr>

              {salesApp.map((sale, index) => (
                <tr key={sale.id}>
                  <td>
                    <Input
                      type="text"
                      name="name"
                      value={sale.nome == 'withApp' ? 'Vendas com App' : 'Vendas online'}
                      disabled
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      id="1"
                      type="text"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, nextNextMonth, originalValue, setSalesApp, salesApp)
                      }
                      value={sale.meses[nextNextMonth]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      id="2"
                      type="text"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, nextMonth, originalValue, setSalesApp, salesApp)
                      }
                      value={sale.meses[nextMonth]}
                    />
                  </td>

                  <td>
                    <CurrencyInput
                      id="3"
                      type="text"
                      name={sale.nome}
                      onChangeValue={(e, originalValue) =>
                        handleChange(e, currentMonthIndex, originalValue, setSalesApp, salesApp)
                      }
                      value={sale.meses[currentMonthIndex]}
                    />
                  </td>
                  <td>
                    <CurrencyInput
                      type="text"
                      name={'avrg'}
                      currency={'percent'}
                      value={avrg(
                        sale.meses,
                        salesAppTotal.sale1 + salesAppTotal.sale2 + salesAppTotal.sale3
                      )}
                      disabled
                    />
                  </td>
                  <td>
                    <Button
                      color={'#3460a6'}
                      onClick={() => handleCloneRow(index, salesApp, setSalesApp)}
                    >
                      <AiFillCaretRight style={{ position: 'absolute' }} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <ButtonSubmit margin={'15px 0px 0px 0px'} onClick={handleSave}>
            Salvar
          </ButtonSubmit>
        </Container>
      </BoxShadow>
    </Content>
  )
}
export default Sales
